<style lang="scss" scoped>
.record-list {
  color: #606266;
}
.course-name {
  font-size: 18px;
}
</style>

<template>
  <div class="record-list">
    <div class="container">
      <el-form :inline="true" class="demo-form-inline" size="mini">
        <el-form-item label="姓名">
          <el-input class="input-width" placeholder="请输入报名者姓名" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input class="input-width" placeholder="请输入报名者手机号" v-model="params.mobile"></el-input>
        </el-form-item>
        <el-form-item label="课程名">
          <el-input class="input-width" placeholder="请输入课程名" v-model="params.coursename"></el-input>
        </el-form-item>
      </el-form>

      <el-button @click="search" size="small">筛选</el-button>
      <el-button @click="clear" style="color: #4E759E;" size="small" type="text">清空筛选条件</el-button>
    </div>
    <div class="container">
      <el-table :data="list">
        <el-table-column prop="name" label="报名人"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="course.name" label="报名课程"></el-table-column>
        <el-table-column prop="createdat" label="报名时间">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.createdat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="container" style="text-align: center;">
      <el-button size="small" :disabled="noMore" type="primary" @click="() => getList()">加载更多</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
import moment from 'moment';

export default {
  data() {
    return {
      token: getToken(),
      params: {
        count: 20,
        courseid: 0,
        mobile: '',
        name: '',
        coursename: this.$route.query.coursename || '',
        idlessthan: 0
      },
      list: [],
      noMore: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.noMore = false;
      this.params.courseid = 0;
      if (this.params.coursename) {
        const res = await rpc(
          'StoreCourseService.GetCourseList',
          M('CourseListQueryRequest', {
            token: M('Token', { token: this.token }),
            count: 1,
            name: this.params.coursename
          })
        );
        if (!res.courselistList.length) {
          this.$message({
            message: '没有更多了',
            type: 'info'
          });
          this.noMore = true;
          return;
        }
        this.params.courseid = res.courselistList[0].id;
      }
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;

      const res = await rpc(
        'StoreApplyCourseService.GetApplyCourseList',
        M('ApplyCourseListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      const list = res.applycourselistList;
      if (!list.length) {
        this.$message({
          message: '没有更多了',
          type: 'info'
        });
        this.noMore = true;
        return;
      }

      const courseidlist = list.map(v => v.courseid);
      const res1 = await rpc(
        'StoreCourseService.GetCourseList',
        M('CourseListQueryRequest', {
          token: M('Token', { token: this.token }),
          idlistList: courseidlist,
          count: courseidlist.length
        })
      );
      list.forEach(item => {
        item.course = res1.courselistList.find(v => v.id == item.courseid);
      });
      this.list = this.list.concat(list);
    },
    clear() {
      this.params = {
        count: 20,
        courseid: 0,
        mobile: '',
        name: '',
        coursename: '',
        idlessthan: 0
      };
      this.list = [];
      this.getList();
    },
    search() {
      this.list = [];
      this.getList();
    }
  }
};
</script>
